export const CLASSNAME_IS_APP_INIT = "is-app-init";
